export const FIREBASE_REGION = 'europe-central2';
